import {otsBaseApi} from "../../ots-api";
import {PermissionABACPolicyAssoc} from "../../../model/permission-abac-policy-assoc";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["PermissionABACPolicyAssocs", "UserPermissionABACPolicyAssoc"]});

const permissionABACPolicyAssocApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserPermissionABACPolicyAssocs: builder.query<
      PermissionABACPolicyAssoc[],
      void
    >({
      query: () => ({
        url: `/permission-abac-policy-assocs`,
        method: 'GET',
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "PermissionABACPolicyAssocs", id} as const)),
            {type: "UserPermissionABACPolicyAssoc", id: "LIST"}
          ];
        } else {
          return [{type: "UserPermissionABACPolicyAssoc", id: "LIST"}];
        }
      },
    }),
  })
});

export const {
  useGetUserPermissionABACPolicyAssocsQuery,
} = permissionABACPolicyAssocApi;
